module.exports = __webpack_public_path__ + "img/www.1d9af78c.svg";